var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconAsterisk = function SvgIconAsterisk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0005 14.0335C21.0005 13.4627 20.5528 13 20.0005 13C19.4482 13 19.0005 13.4627 19.0005 14.0335V18.1551L15.5002 16.1341C15.0219 15.858 14.4103 16.0219 14.1341 16.5002C13.858 16.9785 14.0219 17.5901 14.5002 17.8662L18.0004 19.887L14.5011 21.9073C14.0229 22.1835 13.859 22.7951 14.1351 23.2733C14.4113 23.7516 15.0229 23.9155 15.5011 23.6394L19.0005 21.619V25.9665C19.0005 26.5373 19.4482 27 20.0005 27C20.5528 27 21.0005 26.5373 21.0005 25.9665V21.6192L24.4996 23.6394C24.9779 23.9155 25.5895 23.7516 25.8656 23.2733C26.1418 22.795 25.9779 22.1835 25.4996 21.9073L22.0004 19.887L25.5006 17.8662C25.9789 17.5901 26.1427 16.9785 25.8666 16.5002C25.5905 16.0219 24.9789 15.858 24.5006 16.1341L21.0005 18.1549V14.0335Z",
    fill: "current"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAsterisk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-asterisk.cab78de1.svg";
export { ForwardRef as ReactComponent };